import React, { useState } from 'react';
import { Table, Typography, Avatar, Switch } from 'antd';
import ProgramsAPI from '../../services/sdks/programs';

const AiModels = ({ aiModels, programId }) => {
	const [mainAiModelId, setMainAiModelId] = useState(() => {
		const mainModel = aiModels?.find((model) => model?.isMain === true);
		return mainModel?._id || null;
	});

	const handleMainAiModelChange = async (aiModelId, checked) => {
		if (checked) {
			setMainAiModelId(aiModelId);
			await ProgramsAPI.updateMainAiModel(programId, aiModelId);
		} else {
			setMainAiModelId(null);
			await ProgramsAPI.updateMainAiModel(programId, null);
		}
	};

	const columns = [
		{
			title: 'ID',
			dataIndex: '_id',
			key: 'id',
			render: (_id) => (
				<Typography.Text title={_id} copyable={{ text: _id }}>{`${_id.slice(
					0,
					8
				)}...`}</Typography.Text>
			),
		},
		{
			title: 'Título',
			key: 'title',
			render: (element) => (
				<span style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
					<Avatar src={`https://public-platform.r2.fish.audio/${element.coverImage}`} size={40} />
					{element.title}
				</span>
			),
		},
		{
			title: 'Prioridade',
			key: 'main-model',
			render: (element) => (
				<Switch
					checked={mainAiModelId === element._id}
					onChange={(checked) => handleMainAiModelChange(element._id, checked)}
					checkedChildren={
						<span style={{ minWidth: '70px', display: 'inline-block', textAlign: 'center' }}>
							Principal
						</span>
					}
					unCheckedChildren={
						<span style={{ minWidth: '70px', display: 'inline-block', textAlign: 'center' }}>
							Secundário
						</span>
					}
				/>
			),
		},
	];

	return (
		<>
			<Table
				rowKey='_id'
				pagination={{ size: 'large' }}
				style={{ border: 'none' }}
				loading={!aiModels}
				size='middle'
				columns={columns}
				dataSource={aiModels}
				rowClassName='__row'
			/>
		</>
	);
};

export default AiModels;
